export default __webpack_public_path__ + "static/media/Darlington2hrRapidResponseNursingTeamGeneralGuidanceonRapidResponseNursingServices.4a49f09c.jpg";